import requests from "./httpService";


const RazorpayDetailsServices = {

 RazorpayDetailsList: async () => {
  
    return requests.get(`/razpaydetails/`);
  }


};

export default RazorpayDetailsServices;
